

import { upload, getExtranetUrl } from '../plugins/oss-sdk'
import { getSystemOssByUrl} from '../service/getData'




/** oss 上传图片
 * @param files
 */
export default (e) => {
  return new Promise((resolvewai, reject) => {
    getSystemOssByUrl().then(res => {
      if (res.data.code === 1) {
        let clientConfig = {
          accessKeyId: res.data.data.AccessKeyId,// 通过阿里云控制台创建的access key
          accessKeySecret: res.data.data.AccessKeySecret,// 通过阿里云控制台创建的access secret。
          stsToken: res.data.data.SecurityToken,// 使用临时授权方式。
          bucket: res.data.data.SystemOssBucket,// 通过控制台创建的bucket。
          endpoint: res.data.data.SystemOssEndpoint,// OSS域名。
          SystemOssChannelName: res.data.data.SystemOssChannelName, // 上传指定文件夹
          cname: true, // 是否支持上传自定义域名，默认false。如果cname为true，endpoint传入自定义域名时，自定义域名需要先同bucket进行绑定。
          region: 'oss-cn-hangzhou', // bucket 所在的区域，默认 oss-cn-hangzhou（是根据当前所在区域自动确认的）。
        };
        const config = {
          isNotNeedRequest: true,// 默认为false，即需要请求接口获取配置信息，不需要时，请设置为true。
          clientRequest: clientConfig,// 当isNotNeedRequest为true时必填项，配置项详情请查看OSS上传的配置项文档。https://help.aliyun.com/
        }; // 配置项
        upload(e, config, true).then((resolve) => {
          const result = resolve.data;
          let url = getExtranetUrl(result.name, 2);//获取图片外网访问地址
          resolvewai(
            {
              exportFile: url,
              fileName: result.name,
              imgUrl: url
            }
          )
        }).catch(_ => {
          reject({
            err: _.err
          })
          console.log(_.err);
        })
      } else {
        reject({
          err: res.data.message
        })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/config/oss.js